'use client';
'use strict';

var jsxRuntime = require('react/jsx-runtime');
var generatedCraftcms = require('@liquorice/generated-craftcms');
var createFieldControl = require('../lib/form/createFieldControl.js');
var Field_Dropdown = require('./Field_Dropdown.js');

function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
const FIELD_NAME_PREFIX_FRAGMENT = generatedCraftcms.gql(`
  fragment fieldNamePrefix on Field_NamePrefix {
    __typename
    ...fieldBase
    options {
      ...fieldOption
    }
  }
`);
const Field_NamePrefix = createFieldControl.createField(FIELD_NAME_PREFIX_FRAGMENT, (field, props)=>{
    return /*#__PURE__*/ jsxRuntime.jsx(Field_Dropdown.Field_Dropdown, _extends({
        field: field
    }, props));
});

exports.FIELD_NAME_PREFIX_FRAGMENT = FIELD_NAME_PREFIX_FRAGMENT;
exports.Field_NamePrefix = Field_NamePrefix;
